<script setup lang="ts">
/**
 * A short message about what just happened, in one of four tones.
 *
 * `assertive` on the danger tone so a screen reader interrupts with a failed
 * submit; the others are polite, because a confirmation that cuts across what
 * someone is reading is worse than one that waits.
 *
 * The copy arrives translated. Like every component here, it has no idea which
 * app it is in and does not call `useI18n()`.
 */
withDefaults(defineProps<{ message: string; tone?: 'info' | 'success' | 'warning' | 'danger' }>(), { tone: 'info' });
</script>

<template>
  <p v-if="message" class="hb-notice" :class="`hb-notice--${tone}`" role="status" :aria-live="tone === 'danger' ? 'assertive' : 'polite'">
    {{ message }}
  </p>
</template>

<style scoped>
.hb-notice {
  padding: var(--hb-space-3);
  border: 1px solid transparent;
  border-radius: var(--hb-radius-md);
  font-size: var(--hb-text-sm);
}

.hb-notice--info {
  background: var(--hb-surface-raised);
  border-color: var(--hb-border);
  color: var(--hb-text-muted);
}

.hb-notice--success {
  background: var(--hb-success-subtle);
  border-color: var(--hb-success);
  color: var(--hb-text);
}

.hb-notice--warning {
  background: var(--hb-warning-subtle);
  border-color: var(--hb-warning);
  color: var(--hb-text);
}

.hb-notice--danger {
  background: var(--hb-danger-subtle);
  border-color: var(--hb-danger);
  color: var(--hb-text);
}
</style>
